<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/127PGHj/tc-custom/9781439132081.jpg?1730491663097" alt="This image is the cover for the book Lioness Rampant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lioness Rampant
      </h1>
      <p class="bookDescription body article font2">
        <b>“Tamora Pierce’s books shaped me not only as a young writer but also as a young woman. She is a pillar, an icon, and an inspiration.” —Sarah J. Maas, #1 <i>New York Times</i>–bestselling author of <i>A Court of Thorns and Roses</i></b><br/><br/><i>The conclusion to the Margaret A. Edward Award–winning young-adult fantasy series by #1 </i>New York Times<i>–bestselling author Tamora Pierce . . . </i><br/><br/>Having achieved her dream of becoming the first female knight errant, Alanna of Trebond finds herself at loose ends. She has already triumphed in countless bloody battles, and her adventures are considered legendary. Perhaps being a knight errant is not all that Alanna needs . . . <br/><br/>But Alanna must push her uncertainty aside when she is tasked with the impossible. She must recover the Dominion Jewel, a legendary gem that has enormous power for good . . . in the right hands. And she must work fast. Her archenemy, Duke Roger, is back and more formidable than ever, putting Tortall in great danger. As she puts her hard-won skills to use, Alanna discovers through fierce combat and ceaseless searching that she can make a future worthy of her mythic past—both as a warrior and as a woman.<br/><br/>“Full of slam-bang action.” —<i>Kirkus Reviews</i><br/><br/>“[Pierce’s] heroines cut a swath through the fantasy world with wit, strength, and savvy.” —Leigh Bardugo, #1 <i>New York Times</i>–bestselling author of <i>Six of Crows</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tamora Pierce
      </h2>
      
      <p class="authorDescription body article">Beloved author Tamora Pierce has written a great number of books, including the Song of the Lioness quartet, The Immortals quartet, the Circle of Magic quartet, the Protector of the Small quartet, The Circle Opens quartet, the Trickster series,&#160;<I>The Will of</I>&#160;<I>the Empress</I>,&#160;<I>Melting Stones</I>, the Beka Cooper series, and The Numair Chronicles. She lives in upstate New York with various cats, other four-legged animals, and birds who feed in her yard, and can be e-visited at Tamora-Pierce.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atheneum Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1db22ee